import prizesList from "./prizesList";
import corporateValuesList from "./corporateValuesList";
import vecTeamList from "./vecTeamList"

export { prizesList, corporateValuesList, vecTeamList };



// WEBPACK FOOTER //
// ./src/views/AboutUsPage/assets/index.js